import { useEffect } from "react";

// Lightweight, dependency-free per-page metadata for a CRA SPA.
// Updates <title>, description, OG tags and canonical on mount and
// restores the previous (index.html default) values on unmount.
export function usePageMeta({ title, description, canonical }) {
  useEffect(() => {
    const head = document.head;
    const qs = (s) => head.querySelector(s);
    const descEl = qs('meta[name="description"]');
    const ogTitleEl = qs('meta[property="og:title"]');
    const ogDescEl = qs('meta[property="og:description"]');
    const ogUrlEl = qs('meta[property="og:url"]');
    const canonEl = qs('link[rel="canonical"]');

    const prev = {
      title: document.title,
      desc: descEl && descEl.getAttribute("content"),
      ogTitle: ogTitleEl && ogTitleEl.getAttribute("content"),
      ogDesc: ogDescEl && ogDescEl.getAttribute("content"),
      ogUrl: ogUrlEl && ogUrlEl.getAttribute("content"),
      canon: canonEl && canonEl.getAttribute("href"),
    };

    if (title) {
      document.title = title;
      if (ogTitleEl) ogTitleEl.setAttribute("content", title);
    }
    if (description) {
      if (descEl) descEl.setAttribute("content", description);
      if (ogDescEl) ogDescEl.setAttribute("content", description);
    }
    if (canonical) {
      if (canonEl) canonEl.setAttribute("href", canonical);
      if (ogUrlEl) ogUrlEl.setAttribute("content", canonical);
    }

    return () => {
      document.title = prev.title;
      if (descEl && prev.desc != null) descEl.setAttribute("content", prev.desc);
      if (ogTitleEl && prev.ogTitle != null) ogTitleEl.setAttribute("content", prev.ogTitle);
      if (ogDescEl && prev.ogDesc != null) ogDescEl.setAttribute("content", prev.ogDesc);
      if (ogUrlEl && prev.ogUrl != null) ogUrlEl.setAttribute("content", prev.ogUrl);
      if (canonEl && prev.canon != null) canonEl.setAttribute("href", prev.canon);
    };
  }, [title, description, canonical]);
}
